import React from "react";
import "./Contact.css";
import WOW from 'wowjs';

class Contact extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }

    componentDidMount() {
        new WOW.WOW().init();
    }
    render() {
        return (
            <div className="contact" name="Contact">
                <div className="container">
                    <h2 className="wow animate__animated animate__fadeIn" data-wow-duration="2s" data-wow-delay="1s" data-wow-offset="30">Contact</h2>
                    <div className="contact_main" >
                        <div className="contact_left">
                            <h1>A Wallet for Everyone</h1>
                            <a>
                                Contact our team &nbsp;&nbsp;<img src="img/arrow.svg" />
                            </a>
                            <img className="phone" src="img/phone_contact.png" />
                        </div>
                        <div className="contact_right">
                            <form>
                                <div className="form_block">
                                    <label>Company Name</label>
                                    <input />
                                </div>
                                <div className="form_block">
                                    <label>Email</label>
                                    <input />
                                </div>
                                <div className="form_block">
                                    <label>Your Name</label>
                                    <input />
                                </div>
                                <div className="form_block">
                                    <label>Сountry</label>
                                    <select />
                                </div>
                                <div className="form_block">
                                    <label>Comments</label>
                                    <textarea rows="4"></textarea>
                                </div>
                                <button className="button">Request Invite</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Contact;
